import { createFileRoute } from '@tanstack/react-router'
import {ErrorComponent} from "../../../components/error";

export const Route = createFileRoute('/_site/cwg')({
  errorComponent: ErrorComponent,
})
